jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
   // alert('hi')

  document.addEventListener('DOMContentLoaded', function() {
    const submitBtn = document.querySelector('#apply_cpn');
    const couponCodeSpan = document.querySelector('#cpn_code');
    const inputBox = document.querySelector('#CartDiscountcode');

    submitBtn.addEventListener('click', function() {
        const couponCode = couponCodeSpan.textContent;
        inputBox.value = couponCode;
    });
});


});